export class FeedbackSurvey {

    /**
     * Constructor
     */
    constructor() {
        this.isLoading = false;

        let labels = document.querySelectorAll('.survey-content label');
        for (let i = 0; i < labels.length; i++) {
            labels[i].addEventListener('click', (event) => {
                this.labelClick(event.target);
            });
        }
/*
        let inputs = document.querySelectorAll('.survey-content label');
        for (let i = 0; i < labels.length; i++) {
            labels[i].addEventListener('click', (event) => {
                this.inputChange(event.target);
            });
        }
*/
        let startButton = document.querySelector('.survey-content .start-button');
        if(startButton) {
            startButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.animateCSS(startButton, 'fadeOut', () => {
                    startButton.style.display = 'none';
                    this.start();
                });
            });
        }

        let surveyForm = document.querySelector('.survey-content form[name=survey_standard_form]');
        if(surveyForm) {
            let surveySubmitButton = document.getElementById('surveySubmitButton');
            surveyForm.addEventListener('submit', (event) => {
                surveySubmitButton.disabled = true;
                surveySubmitButton.innerText = 'Sending Feedback';
                return false;
            });
        }

        let formGroups = document.querySelectorAll('.survey-content .form-group');
        this.stepsTotal = formGroups.length-1; // exclude submit button
        this.currentStep = 0;
    }

    /**
     * Start the survey process
     */
    start() {
        let firstFormGroup = document.querySelector('.survey-content .form-group');
        if (firstFormGroup) {
            firstFormGroup.style.display = 'block';
            this.animateCSS(firstFormGroup, 'fadeIn');
            this.progressStep();
        }
    }

    /**
     * Tick a step to increase counter and progress bar
     */
    progressStep() {
        this.currentStep++;
        let progress = Math.round(this.currentStep / this.stepsTotal * 100);
        document.getElementById('feedback-progress').style.width = progress + '%';
        document.getElementById('feedback-progress-percentage').innerText = progress + '%';
    }

    /**
     *
     * @param label
     */
    labelClick(label) {

        let clickedFormGroup = label.closest('.form-group');

        this.animateCSS(label, 'flash', () => {

            let next = clickedFormGroup.nextSibling;

            if (next.nextSibling === null) {
                let submit = document.querySelector('.form-group.survey-submit');
                submit.style.display = 'block';

                this.animateCSS(submit, 'fadeIn');
            }

            this.animateCSS(clickedFormGroup, 'fadeOut', () => {

                clickedFormGroup.style.display = 'none';
                next.style.display = 'block';

                this.progressStep();

                this.animateCSS(next, 'fadeIn');
            });
        });

        // get parent form group -> hide -> get next sibling -> onpageshow
    }


    /**
     *
     * @param input
     */
    inputChange(input) {

    }

    /**
     *
     * @param node
     * @param animationName
     * @param callback
     */
    animateCSS(node, animationName, callback) {
        node.classList.add('animated', 'fast', animationName);

        node.addEventListener(
            'animationend',
            function handleAnimationEnd(event) {
                // alert('animationend'+event.target);
                node.classList.remove('animated', animationName);
                if (typeof callback === 'function') callback()
            },
            {
                once: true
            },
            false
        );
    }

}